import { SessionsReq } from './SessionsDTO.js'

/**
 * Viewer Report Request DTO
 * @extends {SessionsReq}
 */
export interface ViewerReportReq extends SessionsReq {
	/**
	 * Language
	 */
	language: string
	/**
	 * Viewer ID
	 */
	viewer_id: string
}
